import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export type BadgeTone = "neutral" | "brand" | "success" | "danger" | "warning" | "info" | "dark";

const tones: Record<BadgeTone, string> = {
  neutral: "bg-muted text-muted-foreground border-border",
  brand: "bg-sl-yellow-soft text-sl-charcoal border-sl-yellow/60",
  success: "bg-[#EEF6E4] text-success border-[#CFE3B4]",
  danger: "bg-[#FDECEC] text-destructive border-[#F6C4C6]",
  warning: "bg-sl-yellow-soft text-warning border-sl-yellow/50",
  info: "bg-[#E8F0FA] text-info border-[#C4D6EE]",
  dark: "bg-sl-charcoal text-white border-sl-charcoal",
};

export function Badge({ tone = "neutral", className, ...props }: HTMLAttributes<HTMLSpanElement> & { tone?: BadgeTone }) {
  return (
    <span
      className={cn("inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap", tones[tone], className)}
      {...props}
    />
  );
}
